export interface Room {
  slug: string;
  translationKey: string;
  price: number;
  capacity: number;
  images: string[];
  amenities: string[];
  module: 'colonial' | 'modern';
  size: string;
  bed: string;
  room_type_id?: number;
  backend_name?: string;
  backend_description?: string;
}

// NUVA room catalog. Slugs match the normalized backend RoomType names (see
// rooms-merge.ts) so live availability/pricing merges onto these entries;
// prices here are tax-inclusive fallbacks only used while the API loads.
export const rooms: Room[] = [
  {
    slug: 'deluxe-queen',
    translationKey: 'deluxe_queen',
    price: 1964,
    capacity: 2,
    images: [
      '/images/nuva/rooms/room-deluxe-queen-hero.jpeg',
      '/images/nuva/rooms/room-deluxe-queen-gallery-1.jpeg',
      '/images/nuva/rooms/room-deluxe-queen-gallery-2.jpeg',
      '/images/nuva/rooms/room-deluxe-queen-gallery-3.jpeg',
      '/images/nuva/rooms/room-deluxe-queen-gallery-4.jpeg',
      '/images/nuva/rooms/room-deluxe-queen-gallery-5.jpeg',
    ],
    amenities: ['ac', 'wifi', 'tv', 'private_bathroom', 'hot_water', 'workspace'],
    module: 'modern',
    size: '—',
    bed: '1 Queen',
  },
  {
    slug: 'deluxe-queen-balcony',
    translationKey: 'deluxe_queen_balcony',
    price: 2202,
    capacity: 2,
    images: [
      '/images/nuva/rooms/room-deluxe-queen-balcony-hero.jpeg',
      '/images/nuva/rooms/room-deluxe-queen-balcony-gallery-1.jpeg',
      '/images/nuva/rooms/room-deluxe-queen-balcony-gallery-2.jpeg',
      '/images/nuva/rooms/room-deluxe-queen-balcony-gallery-3.jpeg',
      '/images/nuva/rooms/room-deluxe-queen-balcony-gallery-4.jpeg',
      '/images/nuva/rooms/room-deluxe-queen-balcony-gallery-5.jpeg',
    ],
    amenities: ['ac', 'wifi', 'tv', 'private_bathroom', 'hot_water', 'balcony'],
    module: 'modern',
    size: '—',
    bed: '1 Queen',
  },
  {
    slug: 'junior-suite-king',
    translationKey: 'junior_suite_king',
    price: 2440,
    capacity: 2,
    images: [
      '/images/nuva/rooms/room-junior-suite-king-hero.jpeg',
      '/images/nuva/rooms/room-junior-suite-king-gallery-1.jpeg',
      '/images/nuva/rooms/room-junior-suite-king-gallery-2.jpeg',
      '/images/nuva/rooms/room-junior-suite-king-gallery-3.jpeg',
      '/images/nuva/rooms/room-junior-suite-king-gallery-4.jpeg',
      '/images/nuva/rooms/room-junior-suite-king-gallery-5.jpeg',
    ],
    amenities: ['ac', 'wifi', 'tv', 'private_bathroom', 'hot_water', 'sitting_area'],
    module: 'modern',
    size: '—',
    bed: '1 King',
  },
  {
    slug: 'doble-queen',
    translationKey: 'doble_queen',
    price: 2975,
    capacity: 4,
    images: [
      '/images/nuva/rooms/room-doble-queen-hero.jpeg',
      '/images/nuva/rooms/room-doble-queen-gallery-1.jpeg',
      '/images/nuva/rooms/room-doble-queen-gallery-2.jpeg',
      '/images/nuva/rooms/room-doble-queen-gallery-3.jpeg',
      '/images/nuva/rooms/room-doble-queen-gallery-4.jpeg',
      '/images/nuva/rooms/room-doble-queen-gallery-5.jpeg',
    ],
    amenities: ['ac', 'wifi', 'tv', 'private_bathroom', 'hot_water'],
    module: 'modern',
    size: '—',
    bed: '2 Queen',
  },
  {
    slug: 'master-suite',
    translationKey: 'master_suite',
    price: 3570,
    capacity: 4,
    images: [
      '/images/nuva/rooms/room-master-suite-hero.jpeg',
      '/images/nuva/rooms/room-master-suite-gallery-1.jpeg',
      '/images/nuva/rooms/room-master-suite-gallery-2.jpeg',
      '/images/nuva/rooms/room-master-suite-gallery-3.jpeg',
      '/images/nuva/rooms/room-master-suite-gallery-4.jpeg',
      '/images/nuva/rooms/room-master-suite-gallery-5.jpeg',
    ],
    amenities: ['ac', 'wifi', 'tv', 'private_bathroom', 'hot_water', 'living_room', 'minibar'],
    module: 'modern',
    size: '—',
    bed: '2 Queen',
  },
];
